import AceEditor from "react-ace";
import styles from './editor.module.scss';
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/ext-language_tools";

export function CodeEditor({ mode, onChange, value, width, height }) {

  return (
    <AceEditor
      mode={mode}
      onLoad={(editor) => {
        editor.navigateFileStart();
        editor.focus();
        
        setTimeout(() => {
          editor.navigateFileStart();
          editor.focus();
        },10);
      }}
      focus
      width={width || '100%'}
      height={height || '100%'}
      theme="monokai"
      value={value}
      name=""
      className={styles.codeEditor}
      onChange={onChange}
      highlightActiveLine={true}
      editorProps={{ $blockScrolling: true }}
      setOptions={{
        enableBasicAutocompletion: true,
        enableSnippets: true,
        showLineNumbers: true,
        tabSize: 1,
      }}
    />
  )
}